import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function DragHandlerIcon(props) {
	return (
		<SvgIcon {...props} viewBox="0 0 16 6">
			<defs>
				<path
					d="M20,8.99999999 L3.99999997,8.99999999 L3.99999997,11 L20,11 L20,8.99999999 L20,8.99999999 Z M3.99999997,15 L20,15 L20,13 L3.99999997,13 L3.99999997,15 L3.99999997,15 Z"
					id="path-1"
				/>
			</defs>
			<g id="Personal-Website" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g
					id="Personal-Website/Editor/Content/Background"
					transform="translate(-38.000000, -325.000000)"
				>
					<g id="drag_handle" transform="translate(34.000000, 316.000000)">
						<polygon
							id="Base"
							points="-5.00000112e-08 -4.9999926e-08 24 -4.9999926e-08 24 24.0000001 -5.00000112e-08 24.0000001"
						/>
						<mask id="mask-2" fill="white">
							<use xlinkHref="#path-1" />
						</mask>
						<g id="Icon" fillRule="nonzero" />
						<rect
							id="↳-🎨-Color"
							fillOpacity="0.6"
							fill="#EBEBF5"
							mask="url(#mask-2)"
							x="0"
							y="0"
							width="24"
							height="24"
						/>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
}

export default DragHandlerIcon;
